module.exports = __webpack_public_path__ + "fonts/proximanova-light-webfont.f8941ee6.ttf";